export class TdoFileModel {
  thumbnailDataBase64: string;
  fileDataBase64: string;

  thumbnailDataBlob: Blob;
  fileDataBlob: Blob;

  fileMimeType: string;
  thumbMimeType: string;

  originalExtension: string;
  thumbnailExtension: string = 'jpg';
}
